export default {
  // common
  'noName': 'No name',

  // languages
  'cz': 'Czech',
  'en': 'English',

  //report type
  'idea': 'idea',
  'problem': 'problem',

  //report state
  'pending': 'pending',
  'inProgress': 'in progress',
  'solved': 'solved',
  'rejected' : 'rejected',

  //Component block translations
  'empty-category' : '-No category-'
}
